module.exports = {"tag":"video","class":"camera-video"}